/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'
import './myCollections.scss'
import { Link } from 'react-router-dom'
import {Row, Col} from 'react-bootstrap'
import { collectOption } from './collectionData'
import {BiRightArrowAlt} from 'react-icons/bi'

export default function MyCollections() {
  return (
    <div id="mn-my-collections">
        <div className='my-collections-panel'>
            <div className='title p-2'>
                My Collections
            </div>
            <div className='body px-5 py-3'>
                <div className="mb-3 px-5 py-3">
                    <Row>
                        {collectOption.map((op, idx)=>{
                            return(
                                <Col md={4} key={idx} className='collect-options'>
                                    <p><b>[ {op.title} ]</b></p>
                                    <p>Collections of {op.title} questions</p>
                                    <Link to={op.path}>
                                    <button className='redirect-btn'>To practice <BiRightArrowAlt /></button>
                                    </Link>
                                </Col>
                            )
                        })}
                    </Row>
                </div>
            </div>
        </div>
    </div>
  )
}
